import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material'
import ReactTable from './ReactTable'
import fetchFromAthena from '../functions/FetchFromAthena'
import { useCommentCols } from '../hooks/CommentCols'

export default function CommentDialog(props) {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = async () => {
    setOpen(true)
    setIsLoading(true)
    
    try {
      const headers = {
        fileName: props.fileName,
        index: props.index
      }

      const result = await fetchFromAthena({
        queryName: 'sys_comments_read',
        headers: headers,
        accessToken: props.accessToken,
        credentials: props.fetchInitialData.credentials
      })

      setData(result || [])
    } catch (error) {
      console.error('Error fetching comments:', error)
      setData([])
    } finally {
      setIsLoading(false)
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  const columns = useCommentCols();

  return (
    <>
      <div
        className="editLink"
        onClick={handleClick}
        style={{ cursor: 'pointer' }}
      >
        {props.text}
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth
        scroll="body"
      >
        <DialogTitle>Comments</DialogTitle>
        <DialogContent>
          <ReactTable
            cols={columns}
            data={data}
            isLoading={isLoading}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

